<template>
  <div>
    <c-row>
      <c-col sm="6">
        <c-card>
          <c-card-header>
            <strong>Credit Card</strong>
            <small>Form</small>
            <div class="card-header-actions">
              <a
                href="https://coreui.io/vue/docs/components/form-components"
                class="card-header-action"
                rel="noreferrer noopener"
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div>
          </c-card-header>
          <c-card-body>
            <c-row>
              <c-col sm="12">
                <c-input label="Name" placeholder="Enter your name" />
              </c-col>
            </c-row>
            <c-row>
              <c-col sm="12">
                <c-input label="Credit Card Number" placeholder="0000 0000 0000 0000" />
              </c-col>
            </c-row>
            <c-row>
              <c-col sm="4">
                <c-select label="Month" :options="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]" />
              </c-col>
              <c-col sm="4">
                <c-select
                  label="Year"
                  :options="[2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025]"
                />
              </c-col>
              <c-col sm="4">
                <c-input label="CVV/CVC" placeholder="123" />
              </c-col>
            </c-row>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="6">
        <c-card>
          <c-card-header>
            <strong>Company</strong>
            <small>Form</small>
          </c-card-header>
          <c-card-body>
            <c-input label="Company" placeholder="Enter your company name" />
            <c-input label="VAT" placeholder="PL1234567890" />
            <c-input label="Street" placeholder="Enter street name" />
            <c-row>
              <c-col sm="8">
                <c-input label="City" placeholder="Enter your city" />
              </c-col>
              <c-col sm="4">
                <c-input label="Postal code" placeholder="Postal code" />
              </c-col>
            </c-row>
            <c-input label="Country" placeholder="Country name" />
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <strong>Basic Form</strong>
            Elements
          </c-card-header>
          <c-card-body>
            <c-form>
              <c-input
                description="Let us know your full name."
                label="Enter your name"
                horizontal
                autocomplete="name"
              />
              <c-input label="Static" value="Username" horizontal plaintext />
              <c-input label="Text input" description="This is a help text" placeholder="Text" horizontal />
              <c-input label="Date" type="date" horizontal />
              <c-input
                label="Email input"
                description="Please enter your email"
                placeholder="Enter your email"
                type="email"
                horizontal
                autocomplete="email"
              />
              <c-input
                label="Password Input"
                description="Please enter a complex password"
                placeholder="Enter your password"
                type="password"
                horizontal
                autocomplete="current-password"
              />
              <c-input label="Disabled Input" placeholder="Disabled" horizontal disabled />
              <c-textarea label="Textarea" placeholder="Content..." horizontal rows="9" />
              <c-select label="Select" horizontal :options="options" placeholder="Please select" />
              <c-select
                label="Large select"
                size="lg"
                horizontal
                :value.sync="selectedOption"
                :options="selectOptions"
                placeholder="Please select"
              />
              <c-select
                label="Small select"
                size="sm"
                horizontal
                :options="options"
                placeholder="Please select"
                custom
              />
              <c-select label="Select" horizontal :options="options" placeholder="Please select" disabled />
              <template v-for="(name, key) in checkboxNames">
                <div :key="name" class="form-group form-row">
                  <c-col tag="label" sm="3" class="col-form-label">
                    {{ name }}
                  </c-col>
                  <c-col sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <c-input-checkbox
                      v-for="(option, optionIndex) in options"
                      :key="key + option"
                      :label="option"
                      :value="option"
                      :custom="key > 1"
                      :name="`Option 1${key}`"
                      :checked="optionIndex === key"
                      :inline="key % 2 === 1"
                    />
                  </c-col>
                </div>
              </template>
              <template v-for="(name, key) in radioNames">
                <div :key="name" class="form-row form-group">
                  <c-col sm="3">
                    {{ name }}
                  </c-col>
                  <c-col sm="9" :class="key % 2 === 1 ? 'form-inline' : ''">
                    <c-input-radio
                      v-for="(option, optionIndex) in options"
                      :key="key + option"
                      :label="option"
                      type="radio"
                      :value="option"
                      :custom="key > 1"
                      :name="`Option 1${key}`"
                      :checked="optionIndex === key"
                      :inline="key % 2 === 1"
                    />
                  </c-col>
                </div>
              </template>
              <c-input-file label="File input" horizontal />
              <c-input-file label="Multiple file input" horizontal multiple />
              <c-input-file label="File custom input" horizontal custom />
              <c-input-file label="Multiple file custom input" horizontal multiple custom />
            </c-form>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="primary">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
        <c-card>
          <c-card-header>
            <strong>Inline</strong>
            Form
          </c-card-header>

          <c-card-body>
            <!-- Bootstrap Vue has some problems with Inline forms that's why we use some standard bootstrap classes -->
            <c-form inline>
              <c-input class="mr-2" placeholder="Jane Doe">
                <template #label>
                  <small>Name:&nbsp;</small>
                </template>
              </c-input>
              <c-input placeholder="jane.doe@example.com" autocomplete="email">
                <template #label>
                  <small>Email:&nbsp;</small>
                </template>
              </c-input>
            </c-form>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="primary">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
      </c-col>
      <c-col md="6">
        <c-card>
          <c-card-header>
            <strong>Horizontal</strong>
            Form
          </c-card-header>
          <c-card-body>
            <c-form>
              <c-input
                type="email"
                description="Please enter your email."
                autocomplete="email"
                label="Email"
                horizontal
                placeholder="Enter Email..."
              />
              <c-input
                type="password"
                description="Please enter your password."
                autocomplete="current-password"
                label="Password"
                horizontal
                placeholder="Enter Password..."
              />
            </c-form>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="primary">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
        <c-card>
          <c-card-header>
            <strong>Normal</strong>
            Form
          </c-card-header>
          <c-form novalidate>
            <c-card-body>
              <c-input
                type="email"
                description="Please enter your email."
                autocomplete="email"
                label="Email"
                placeholder="Enter Email..."
                required
                was-validated
              />
              <c-input
                type="password"
                description="Please enter your password."
                autocomplete="current-password"
                label="Password"
                placeholder="Enter Password..."
                required
                was-validated
              />
            </c-card-body>
            <c-card-footer>
              <c-button type="submit" size="sm" color="primary">
                <c-icon name="cil-check-circle" />
                Submit
              </c-button>
              <c-button type="reset" size="sm" color="danger">
                <c-icon name="cil-ban" />
                Reset
              </c-button>
            </c-card-footer>
          </c-form>
        </c-card>
        <c-card>
          <c-card-header>
            Input
            <strong>Grid</strong>
          </c-card-header>
          <c-card-body>
            <c-row class="form-group">
              <c-col sm="3">
                <c-input class="mb-0" placeholder=".col-sm-3" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="4">
                <c-input class="mb-0" placeholder=".col-sm-4" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="5">
                <c-input class="mb-0" placeholder=".col-sm-5" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="6">
                <c-input class="mb-0" placeholder=".col-sm-6" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="7">
                <c-input class="mb-0" placeholder=".col-sm-7" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="8">
                <c-input class="mb-0" placeholder=".col-sm-8" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="9">
                <c-input class="mb-0" placeholder=".col-sm-9" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="10">
                <c-input class="mb-0" placeholder=".col-sm-10" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="11">
                <c-input class="mb-0" placeholder=".col-sm-11" />
              </c-col>
            </c-row>
            <c-row class="form-group">
              <c-col sm="12">
                <c-input class="mb-0" placeholder=".col-sm-12" />
              </c-col>
            </c-row>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="primary">
              <c-icon name="cil-user" />
              Login
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
        <c-card>
          <c-card-header>
            Input
            <strong>Sizes</strong>
          </c-card-header>
          <c-card-body>
            <c-input label="Small input" size="sm" horizontal placeholder="size='sm'" />
            <c-input label="Default input" horizontal placeholder="normal" />
            <c-input label="Large input" size="lg" horizontal placeholder="size='lg'" />
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="primary">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="12" md="6">
        <c-card>
          <c-card-header>
            <strong>Basic Validation</strong>
            Form
          </c-card-header>
          <c-card-body>
            <c-form validated novalidate>
              <c-input label="Input is valid" valid-feedback="Input is not required." />
              <c-input
                label="Input is invalid"
                required
                valid-feedback="Thank you :)"
                invalid-feedback="Please provide a required input."
              />
            </c-form>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="12" md="6">
        <c-card>
          <c-card-header>
            <strong>Custom Validation</strong>
            Form
          </c-card-header>
          <c-card-body>
            <c-form>
              <c-input
                label="Input is valid"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide at least 4 characters."
                value="Valid value"
                :is-valid="validator"
              />
              <c-input
                label="Input is invalid"
                valid-feedback="Thank you :)"
                invalid-feedback="Please provide at least 4 characters."
                :is-valid="validator"
              />
            </c-form>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="4">
        <c-card>
          <c-card-header>
            <strong>Icon/Text</strong>
            Groups
          </c-card-header>
          <c-card-body>
            <c-input placeholder="Username">
              <template #prepend-content><c-icon name="cil-user" /></template>
            </c-input>
            <c-input type="email" placeholder="Email" autocomplete="email">
              <template #append-content><c-icon name="cil-envelope-open" /></template>
            </c-input>
            <c-input placeholder="ex. $1.000.000" append=".00">
              <template #prepend-content><c-icon name="cil-euro" /></template>
            </c-input>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="success">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
      </c-col>
      <c-col sm="4">
        <c-card>
          <c-card-header>
            <strong>Buttons</strong>
            Groups
          </c-card-header>
          <c-card-body>
            <c-input placeholder="Username">
              <template #prepend>
                <c-button color="primary">
                  <c-icon name="cil-magnifying-glass" />
                  Search
                </c-button>
              </template>
            </c-input>
            <c-input type="email" placeholder="Email" autocomplete="email">
              <template #append>
                <c-button type="submit" color="primary">Submit</c-button>
              </template>
            </c-input>
            <c-input type="email" placeholder="Email" autocomplete="email">
              <template #prepend>
                <c-button color="primary"><c-icon name="cib-facebook" /></c-button>
              </template>
              <template #append>
                <c-button color="primary"><c-icon name="cib-twitter" /></c-button>
              </template>
            </c-input>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="success">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
      </c-col>
      <c-col sm="4">
        <c-card>
          <c-card-header>
            <strong>Dropdowns</strong>
            Groups
          </c-card-header>
          <c-card-body>
            <c-input placeholder="Username">
              <template #prepend>
                <c-dropdown toggler-text="Action" color="primary">
                  <c-dropdown-item>Action</c-dropdown-item>
                  <c-dropdown-item>Another action</c-dropdown-item>
                  <c-dropdown-item>Something else here...</c-dropdown-item>
                  <c-dropdown-item disabled>Disabled action</c-dropdown-item>
                </c-dropdown>
              </template>
            </c-input>
            <c-input type="email" placeholder="Email" autocomplete="email">
              <template #append>
                <c-dropdown toggler-text="Action" color="primary" right>
                  <c-dropdown-item>Action</c-dropdown-item>
                  <c-dropdown-item>Another action</c-dropdown-item>
                  <c-dropdown-item>Something else here...</c-dropdown-item>
                  <c-dropdown-item disabled>Disabled action</c-dropdown-item>
                </c-dropdown>
              </template>
            </c-input>
            <c-input placeholder="...">
              <template #prepend>
                <c-dropdown toggler-text="Split" color="primary" split>
                  <c-dropdown-item href="#">Action</c-dropdown-item>
                  <c-dropdown-item href="#">Another action</c-dropdown-item>
                  <c-dropdown-item href="#">Something else here...</c-dropdown-item>
                  <c-dropdown-item disabled>Disabled action</c-dropdown-item>
                </c-dropdown>
              </template>

              <template #append>
                <c-dropdown toggler-text="Action" color="primary" right>
                  <c-dropdown-item>Action</c-dropdown-item>
                  <c-dropdown-item>Another action</c-dropdown-item>
                  <c-dropdown-item>Something else here...</c-dropdown-item>
                  <c-dropdown-item disabled>Disabled action</c-dropdown-item>
                </c-dropdown>
              </template>
            </c-input>
          </c-card-body>
          <c-card-footer>
            <c-button type="submit" size="sm" color="success">
              <c-icon name="cil-check-circle" />
              Submit
            </c-button>
            <c-button type="reset" size="sm" color="danger">
              <c-icon name="cil-ban" />
              Reset
            </c-button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col md="6">
        <c-card>
          <c-card-header>
            Use the grid for big devices!
            <small>
              <code>.col-lg-*</code>
              <code>.col-md-*</code>
              <code>.col-sm-*</code>
            </small>
          </c-card-header>
          <c-card-body>
            <c-row v-for="(number, key) in [4, 5, 6, 7, 8]" :key="key" class="form-group">
              <c-col :col="12 - number">
                <c-input class="mb-0" :placeholder="`.col-md-${12 - number}`" />
              </c-col>
              <c-col :col="number">
                <c-input class="mb-0" :placeholder="`.col-md-${number}`" />
              </c-col>
            </c-row>
          </c-card-body>
          <c-card-footer>
            <c-button size="sm" color="primary">Action</c-button>
            <c-button size="sm" color="danger">Action</c-button>
            <c-button size="sm" color="warning">Action</c-button>
            <c-button size="sm" color="info">Action</c-button>
            <c-button size="sm" color="success">Action</c-button>
          </c-card-footer>
        </c-card>
      </c-col>
      <c-col md="6">
        <c-card>
          <c-card-header>
            Input Grid for small devices!
            <small><code>.col-*</code></small>
          </c-card-header>
          <c-card-body>
            <c-row v-for="(number, key) in [4, 5, 6, 7, 8]" :key="key" class="form-group">
              <c-col :col="number">
                <c-input class="mb-0" :placeholder="`.col-${number}`" />
              </c-col>
              <c-col :col="12 - number">
                <c-input class="mb-0" :placeholder="`.col-${12 - number}`" />
              </c-col>
            </c-row>
          </c-card-body>
          <c-card-footer>
            <c-button size="sm" color="primary">Action</c-button>
            <c-button size="sm" color="danger">Action</c-button>
            <c-button size="sm" color="warning">Action</c-button>
            <c-button size="sm" color="info">Action</c-button>
            <c-button size="sm" color="success">Action</c-button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="4">
        <c-card>
          <c-card-header>
            Example Form
          </c-card-header>
          <c-card-body>
            <c-form>
              <c-input prepend="Username">
                <template #append-content><c-icon name="cil-user" /></template>
              </c-input>
              <c-input type="email" autocomplete="email" prepend="Email">
                <template #append-content><c-icon name="cil-envelope-closed" /></template>
              </c-input>
              <c-input type="password" autocomplete="current-password" prepend="Password">
                <template #append-content><c-icon name="cil-shield-alt" /></template>
              </c-input>
              <div class="form-group form-actions">
                <c-button type="submit" size="sm" color="primary">
                  Submit
                </c-button>
              </div>
            </c-form>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="4">
        <c-card>
          <c-card-header>
            Example Form
          </c-card-header>
          <c-card-body>
            <c-form>
              <c-input placeholder="Username">
                <template #append-content><c-icon name="cil-user" /></template>
              </c-input>
              <c-input placeholder="Email" type="email" autocomplete="email">
                <template #append-content><c-icon name="cil-envelope-closed" /></template>
              </c-input>
              <c-input placeholder="Password" type="password" autocomplete="current-password">
                <template #append-content><c-icon name="cil-shield-alt" /></template>
              </c-input>
              <div class="form-group form-actions">
                <c-button type="submit" class="btn btn-sm btn-secondary">
                  Submit
                </c-button>
              </div>
            </c-form>
          </c-card-body>
        </c-card>
      </c-col>
      <c-col sm="4">
        <c-card>
          <c-card-header>
            Example Form
          </c-card-header>
          <c-card-body>
            <c-form>
              <c-input placeholder="Username">
                <template #prepend-content><c-icon name="cil-user" /></template>
              </c-input>
              <c-input placeholder="Email" type="email" autocomplete="email">
                <template #prepend-content><c-icon name="cil-envelope-closed" /></template>
              </c-input>
              <c-input placeholder="Password" type="password" autocomplete="current-password">
                <template #prepend-content><c-icon name="cil-shield-alt" /></template>
              </c-input>
              <div class="form-group form-actions">
                <c-button type="submit" size="sm" color="success">
                  Submit
                </c-button>
              </div>
            </c-form>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col lg="12">
        <transition name="fade">
          <c-card v-if="show">
            <c-card-header>
              <c-icon name="cil-pencil" />
              Form Elements
              <div class="card-header-actions">
                <c-link href="#" class="card-header-action btn-setting">
                  <c-icon name="cil-settings" />
                </c-link>
                <c-link class="card-header-action btn-minimize" @click="formCollapsed = !formCollapsed">
                  <c-icon :name="`cil-chevron-${formCollapsed ? 'bottom' : 'top'}`" />
                </c-link>
                <c-link href="#" class="card-header-action btn-close" @click="show = !show">
                  <c-icon name="cil-x-circle" />
                </c-link>
              </div>
            </c-card-header>
            <c-collapse :show="formCollapsed">
              <c-card-body>
                <c-input
                  label="Prepended text"
                  description="Here's some help text"
                  type="email"
                  autocomplete="email"
                  prepend="@"
                />
                <c-input label="Appended text" append=".00" description="Here's some help text" />
                <c-input
                  label="Appended and prepended text"
                  append=".00"
                  description="Here's some help text"
                  prepend="$"
                />
                <c-input label="Append with button" description="Here's some help text">
                  <template #append>
                    <c-button color="primary">Go!</c-button>
                  </template>
                </c-input>
                <c-input label="Two-buttons append">
                  <template #append>
                    <c-button color="primary">Search</c-button>
                    <c-button color="danger">Options</c-button>
                  </template>
                </c-input>
                <div class="form-actions">
                  <c-button type="submit" color="primary">Save changes</c-button>
                  <c-button color="secondary">Cancel</c-button>
                </div>
              </c-card-body>
            </c-collapse>
          </c-card>
        </transition>
      </c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'Forms',
  data() {
    return {
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label: 'col-3', input: 'col-9' },
      options: ['Option 1', 'Option 2', 'Option 3'],
      selectOptions: [
        'Option 1',
        'Option 2',
        'Option 3',
        {
          value: ['some value', 'another value'],
          label: 'Selected option',
        },
      ],
      selectedOption: ['some value', 'another value'],

      formCollapsed: true,
      checkboxNames: ['Checkboxes', 'Inline Checkboxes', 'Checkboxes - custom', 'Inline Checkboxes - custom'],
      radioNames: ['Radios', 'Inline Radios', 'Radios - custom', 'Inline Radios - custom'],
    };
  },
  methods: {
    validator(val) {
      return val ? val.length >= 4 : false;
    },
  },
};
</script>
